"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancellationTokenError = function (_Error) {
  _inherits(CancellationTokenError, _Error);

  function CancellationTokenError() {
    _classCallCheck(this, CancellationTokenError);

    return _possibleConstructorReturn(this, (CancellationTokenError.__proto__ || Object.getPrototypeOf(CancellationTokenError)).call(this, "Cancellation request received"));
  }

  return CancellationTokenError;
}(Error);

module.exports = CancellationTokenError;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhbmNlbGxhdGlvblRva2VuRXJyb3IuanMiXSwibmFtZXMiOlsiRXJyb3IiLCJbb2JqZWN0IE9iamVjdF0iLCJtb2R1bGUiLCJleHBvcnRzIiwiQ2FuY2VsbGF0aW9uVG9rZW5FcnJvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFDSUMsb0NBQUFBO0FBQUFBOztBQUFBQSwySUFDVSwrQkFEVkE7QUFDVTs7O0VBRndCRCxLOztBQU10Q0UsT0FBT0MsT0FBUEQsR0FBaUJFLHNCQUFqQkYifQ==